import styled from "styled-components";
import { Card } from "components/common";
export const Wrapper = styled(Card)`
border: 0;

.ant-card-body {
  border: none;
  /* border-top: 2px solid #bfb5b5; */
  padding: 10px 24px 10px 24px !important;
}
.main-container {
  display: flex;
  justify-content: space-between;
}

.name-div {
  display: flex;
  justify-content: space-between;
}
.flex-name {
  h6 {
    font-size: 20px;
    font-weight: bold;
  }
}
.flex-date {
  h6 {
    font-style: italic;
    font-size: 15px;
  }
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  h6 {
    color: #6e6262d9;
    font-size: 15px;
  }
  h5 {
    font-size: 15px;
  }
}
.image-container {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
.image {
  border-radius: 50%;
  width: 60px;
  height: 60px;
  background: none;
}
.edit-button {
  color: #3a96b8;
  background: transparent;
  border: 1px solid #3a96b8;
  :hover {
    background: #3a96b8;
    color: #ffffff;
    border: 1px solid white;
  }
}
.action-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #6e6262d9;
  margin-left: 10px;
}
.flex-appoinment {
  h6 {
    color: red;
    font-weight: bold;
    font-size: 15px;
  }
}
.flex-tag {
  background-color: #6663cb;
  width: 60px;
  display: flex;
  justify-content: center;
  border-radius: 5px;
  padding: 5px 10px;
  h6 {
    margin: 0px;
    color: #fff;
    font-size: 10px;
  }
}

`